<template>
  <BjAlert ref="alert" class="bottom transition-box" title="" :show-icon="false" center />
</template>
<script>
export default {
  data() {
    return {
      timer: null,
    };
  },
  computed: {},
  methods: {
    show(description) {
      this.timer = null;
      this.$refs.alert.show(description);
      this.timer = setTimeout(() => {
        this.$refs.alert.hide();
        this.timer = null;
      }, 5000);
    },
  },
};
</script>
<style scoped lang="scss">
.bottom {
  position: fixed;
  bottom: 10%;
  width: calc(100% - 32px);
  left: 16px;
  right: 16px;
  z-index: 9998;
  height: 200px;
  filter: opacity(0.9);
}
::v-deep .el-alert__description {
  font-size: 40px;
  color: $danger !important;
}
</style>
